import { colors } from '../constants/colors';
import {
  BANK_CREDIT_PENDING,
  BANK_CREDIT_ACCEPTED,
  BANK_CREDIT_REJECTED,
  BANK_CREDIT_WAITING,
  BANK_CREDIT_REGISTERED,
} from '../constants/bankCreditStatuses';

const sum = (banks, ids) => ids.reduce((total, id) => total + (banks?.[id] || 0), 0);

/**
 * ÐÐ°Ðº Ð±Ð°Ð½ÐºÐ¸ Ð¾ÑÐ²ÐµÑÐ¸Ð»Ð¸ Ð¿Ð¾ ÑÐ´ÐµÐ»ÐºÐµ, Ð¾Ð´Ð½Ð¾Ð¹ ÑÑÑÐ¾ÐºÐ¾Ð¹ Ð´Ð»Ñ ÑÐ°Ð±Ð»Ð¸ÑÑ ÑÐ´ÐµÐ»Ð¾Ðº Ð»Ð¸Ð´Ð°:
 * [{ text: '1 Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¾', color }, { text: '2 Ð¾ÑÐºÐ°Ð·Ð°Ð½Ð¾', color }, ...].
 * banks â { statusId: ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð·Ð°ÑÐ²Ð¾Ðº } Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ Ð»Ð¸Ð´Ð° (deals[].banks).
 * ÐÑÐ¼ÐµÐ½ÑÐ½Ð½ÑÐµ Ð·Ð°ÑÐ²ÐºÐ¸ Ð½Ðµ ÑÑÐ¸ÑÐ°ÐµÐ¼: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð¾Ð½Ð¸ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð³Ð¾Ð²Ð¾ÑÑÑ.
 */
const leadBankSummary = (banks) => {
  const approved = sum(banks, [BANK_CREDIT_ACCEPTED]);
  const rejected = sum(banks, [BANK_CREDIT_REJECTED]);
  const waiting = sum(banks, [BANK_CREDIT_PENDING, BANK_CREDIT_WAITING, BANK_CREDIT_REGISTERED]);

  const parts = [];
  if (approved) parts.push({ text: `${approved} Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¾`, color: colors.green });
  if (waiting) parts.push({ text: `${waiting} Ð¶Ð´ÑÐ¼`, color: colors.dimGray });
  if (rejected) parts.push({ text: `${rejected} Ð¾ÑÐºÐ°Ð·Ð°Ð½Ð¾`, color: colors.red });
  return parts;
};

export default leadBankSummary;
